var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useLocation, useParams } from 'react-router-dom';
import { useAuthProvider } from '#context';
import { isPendingMember } from '#services';
import { WorkspaceMemberActive, WorkspaceMemberPending } from './components';
export const WorkspaceNavigation = ({ workspace, }) => {
    _react_refresh_temp_2();
    const { workspaceId = '' } = useParams();
    const { pathname } = useLocation();
    const { currentUser } = useAuthProvider();
    const isOnCurrentWorkspaceDashboard = new RegExp(`/workspaces/${workspaceId}$`).test(pathname);
    const isPending = isPendingMember(workspace, currentUser);
    if (isPending) {
        return (_jsx(WorkspaceMemberPending, { isOnCurrentWorkspaceDashboard: isOnCurrentWorkspaceDashboard, workspace: workspace }));
    }
    return (_jsx(WorkspaceMemberActive, { isOnCurrentWorkspaceDashboard: isOnCurrentWorkspaceDashboard, workspace: workspace }));
};
_react_refresh_temp_1 = WorkspaceNavigation;
$RefreshReg$(_react_refresh_temp_1, "WorkspaceNavigation");
_react_refresh_temp_2(WorkspaceNavigation, "Q/qJ2JhWCjbhE9D3XnVyb1nBMB8=", false, () => [useParams, useLocation, useAuthProvider]);
